<template>
  <div :class="{ show: show }" class="screen">
    <div id="main-video" class="main-video"></div>
    <div class="screen__backDrop" @click="unactive()"></div>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useMainStore } from "@/store";

export default {
  name: "IdleScreenComponent",
  data() {
    return {
      player: null,
      show: false,
      index: 0,
      playing: null,
    };
  },
  computed: {
    ...mapState(useMainStore, {
      videoList: (store) => store.videoList,
      idleScreen: (store) => store.idleScreen,
    }),
  },
  mounted() {
    this.mountYouTubeApi();
  },
  watch: {
    idleScreen() {
      if (this.idleScreen) {
        this.start();
      }
    },
  },
  methods: {
    mountYouTubeApi() {
      var firstScriptTag = document.getElementsByTagName("script")[0];

      if (!firstScriptTag.src.includes("youtube")) {
        let tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        window.onYouTubeIframeAPIReady = this.initPlayer;
      } else {
        this.initPlayer();
      }
    },
    initPlayer() {
      const mainVideoEl = document.getElementById("main-video");
      this.player = new window.YT.Player(mainVideoEl, {
        width: "100%",
        height: "100%",
        playerVars: {
          autoplay: 0,
          autohide: 0,
          disablekb: 1,
          mute: 1,
          playsinline: 1,
          controls: 0,
          showinfo: 0,
          modestbranding: 1,
          loop: 1,
          fs: 0,
          rel: 0,
          enablejsapi: 1,
          listType: "playlist",
          list: this.videoList,
        },
        events: {
          onStateChange: (event) => {
            if (event.data === 1) {
              event.target.setPlaybackQuality("highres");
              this.show = true;
            }
          },
        },
      });
    },
    start() {
      this.player.playVideo();
    },
    killPlayer() {
      this.player.stopVideo();
    },
    unactive() {
      this.show = false;
      this.setIdleScreen(false);
      setTimeout(this.killPlayer, 1000);
    },
    ...mapActions(useMainStore, ["setIdleScreen"]),
  },
};
</script>

<style lang="scss" scoped>
.screen {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  background: $white;
  visibility: hidden;
  opacity: 0;
  transition: all 500ms ease-in-out;

  &.show {
    visibility: visible;
    opacity: 1;
  }

  &__backDrop {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 10001;
    top: 0;
    left: 0;
  }
}
</style>
